<template>
    <v-list class="pa-0" two-line>
        <v-list-item>
            <v-list-item-action v-if="icon">
                <v-icon color="primary">{{icon}}</v-icon>
            </v-list-item-action>
            <v-list-item-action v-if="avatarSrc">
                <v-avatar>
                    <v-img :src="avatarSrc" @click="actionClick"/>
                </v-avatar>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-subtitle style="font-size: 12px;user-select: text;">{{title}}</v-list-item-subtitle>
                <v-tooltip top v-if="showTooltip">
                    <template v-slot:activator="{ on }">
                        <v-list-item-title style="font-size: 17px; user-select: text;" v-on="on">{{sub_title?sub_title:'n/a'}}</v-list-item-title>
                    </template>
                    <span v-if="sub_title">{{sub_title}}</span>
                </v-tooltip>

                <v-list-item-title style="font-size: 17px; user-select: text;" v-else>{{sub_title?sub_title:'n/a'}}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-divider :inset="inset" v-if="divider"/>
    </v-list>
</template>

<script>
    export default {
        name: "ListItemDetail",
        props: {
            showTooltip: {
                type: Boolean,
                default: false
            },
            title: {
                type: [String, Number, Boolean],
                default: false
            },
            value: {
                type: [String, Number, Boolean],
                default: false
            },
            sub_title: {
                type: [String, Number, Boolean],
                default: "n/a"
            },
            icon: {
                type: [String],
                default: ''
            },
            divider: {
                type: [Boolean],
                default: false
            },
            inset: {
                type: [Boolean],
                default: false
            },
            avatarSrc: {
                type: [String],
                default: ''
            }
        },
        data() {
            return {
                innerValue: null
            }
        },
        watch: {
            innerValue(new_value) {
                this.$emit('input', new_value)
            },
            value(new_value) {
                this.innerValue = new_value
            },
            sub_title(new_value) {
                this.innerValue = new_value;
            }
        },
        methods: {
            actionClick() {
                this.$emit('actionClick')
            }
        },
    }
</script>

<style scoped>

</style>
